export default __webpack_public_path__ + "static/media/blue-waves.2fa4c7d9.svg";